module.exports = __webpack_public_path__ + "img/startup_icon.8beffe70.png";